import { JSX } from 'react'

type Props = {
  content: JSX.Element
}

const Banner = ({ content }: Props) => {
  return <div className='bg-primary-400 p-2 text-white'>{content}</div>
}

export default Banner
